<style>
   .btn-custom {
        background-color: #6985f5; /* Color del fondo */
        color: white; /* Color del texto y el ícono */
        border: none; /* Quita el borde predeterminado */
        border-radius: 10px; /* Bordes redondeados */
        padding: 10px; /* Espaciado interno */
        width: 45px; /*Ancho del botón*/
        height: 45px; /* Alto del botón (cuadrado) */
        font-size: 14px; /* Tamaño del texto */
        align-items: center; /* Centramos el ícono verticalmente */
        cursor: pointer; /* Cambia el cursor al pasar el mouse */
        transition: background-color 0.3s; /* Efecto de transición para el color */
    }

    .btn-custom:hover {
        background-color: #3258f2; /* Color al pasar el mouse */
    }

    .btn-custom i {
        margin-right: 0; /* Quitar el margen derecho para que el ícono esté centrado */
    }


    .btn-custom-delete {
        background-color: #f93103ea; /* Color del fondo */
        color: white; /* Color del texto y el ícono */
        border: none; /* Quita el borde predeterminado */
        border-radius: 10px; /* Bordes redondeados */
        padding: 10px; /* Espaciado interno */
        width: 45px; /*Ancho del botón*/
        height: 45px; /* Alto del botón (cuadrado) */
        font-size: 14px; /* Tamaño del texto */
        align-items: center; /* Centramos el ícono verticalmente */
        cursor: pointer; /* Cambia el cursor al pasar el mouse */
        transition: background-color 0.3s; /* Efecto de transición para el color */
    }

    .btn-custom-delete:hover {
        background-color: #f90000; /* Color al pasar el mouse */
    }

    .btn-custom-delete i {
        margin-right: 0; /* Quitar el margen derecho para que el ícono esté centrado */
    }
</style>
<template>
    <div class="h-100">
        <app-overlay-loader v-if="preloader" />
        <div class="card-body">
            <form ref="form" data-url="/crud" class="mb-0" :class="{ 'loading-opacity': preloader }">
                <div class="row h-100">
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th style="width: 5%;" class="text-center">Number</th>
                                <th style="width: 10%;" class="text-center">Revision Po</th>
                                <th style="width: 10%;" class="text-center">Revision So</th>
                                <th style="width: 15%;" class="text-center">Date</th>
                                <th style="width: 40%;" class="text-center">Description</th>
                                <th style="width: 20%;" class="text-center">Print</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style="width: 5%;"  class="text-center">0</td>
                                <td style="width: 10%;" class="text-center">-</td>
                                <td style="width: 10%;" class="text-center">-</td>
                                <td style="width: 15%;" class="text-center">-</td>
                                <td style="width: 30%;" class="text-center">-</td>
                                <td style="width: 30%;" class="text-center">
                                    <button class="btn-custom" @click.prevent="handleClick('PO')">
                                        <i class="fas fa-file-pdf"></i> PO
                                    </button>
                                    <button class="btn-custom" @click.prevent="handleClick('SO')">
                                        <i class="fas fa-file-pdf"></i> SO
                                    </button>
                                </td>
                            </tr>
                            <tr v-for="(item, index) in revisions" :key="index">
                                <td style="width: 5%;" class="text-center">{{ index+1 }}</td>
                                <td style="width: 10%;" class="text-center">{{ item.revision_po_no }}</td>
                                <td style="width: 10%;" class="text-center">{{ item.revision_so_no }}</td>
                                <td style="width: 15%;" class="text-center">{{ item.date }}</td>
                                <td style="width: 30%;" class="text-center" v-html="item.revision"></td>
                                <td style="width: 30%;" class="text-center">
                                    <button class="btn-custom" @click.prevent="handleClick('PO', item.revision_no)">
                                        <i class="fas fa-file-pdf"></i> PO
                                    </button>
                                    <button class="btn-custom" @click.prevent="handleClick('SO', item.revision_no)">
                                        <i class="fas fa-file-pdf"></i> SO
                                    </button>
                                    <button class="btn-custom-delete" @click.prevent="openDeleteModal(item.id)">
                                        <i class="fas fa-trash"></i> Del
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <br><br>
                    <div class="col-6 col-md-4 mb-2">
                        <button type="button" class="btn btn-success w-100" 
                            @click="submitForm">
                            {{ $t('Go back') }}
                        </button>
                    </div>
                </div>
            </form>
        </div>

        <app-delete-modal 
            v-if="deleteConfirmationModalActive" 
            :preloader="deleteLoader" 
            :message="`Before deleting the revision, please keep the following in mind:
                Deleting the revision does not revert the contract data; it only deletes the record of the revision.
                Make sure you have not sent any documents containing the versions to be deleted, as this could lead to conflicting versions of the same revision being created.`"
            modal-id="demo-delete"
            @confirmed="confirmed" 
            @cancelled="cancelled" />
    </div>
</template>

<script>


export default {
    data() {
        return {
            contractId : null, 
            revisions : [],
            preloader : false,
            deleteConfirmationModalActive : false,
            deleteLoader: false,
            rowIdDelete : null,
        }
    },
    methods: {
        async loadRevisionDetails(id) {
            /* La ídea es que con esta funcion obtengamos los datos solo cuando se ingresa por primera vez
               teniendo en cuenta que se maneja persistencia de datos y que en la edicion de contratos el localstorage
               tendra un diferente nombre para que no se cruce con la craeación */
            if (id) {
                try {
                    const response = await axios.get(`/contracts/get_contract_revision/${id}`);                  
                    const data = response.data;
                    if (data.length > 0) {
                        const res = data;       
                        for (const item of res){
                            let revision = '';
                            let date = '';
                            let description = '';
                            if (item.revision_no != 0) {
                                date = item.created_at;
                                const dateF = new Date(date);
                                const year = dateF.getFullYear();
                                const month = String(dateF.getMonth() + 1).padStart(2, '0'); // Los meses van de 0 a 11, así que sumamos 1
                                const day = String(dateF.getDate()).padStart(2, '0');
                                const formattedDate = `${year}-${month}-${day}`;

                                const obj = {
                                    'id'    : item.id,
                                    'revision_no' : item.revision_no,
                                    'revision_po_no' : item.revision_po_no,
                                    'revision_so_no' : item.revision_so_no,
                                    'date' : formattedDate,
                                    'revision' : item.modification_comment.trim().replace(/,$/, ''),
                                    'description' : description,
                                }
                                this.revisions.push(obj);
                            }
                        }
                        console.log(this.revisions);
                        
                    }
                } catch (error) {
                    console.error('Error fetching contract:', error);
                } 
            }
        },

        openDeleteModal(id) {
            this.rowIdDelete = id;
            this.deleteConfirmationModalActive = true;
        },

        cancelled() {
            this.rowIdDelete = null;
            this.deleteConfirmationModalActive = false;
        },

        async deleteRevision (id) {
            const response = await axios.delete(`/api/contracts/delete_revision/${id}`);
            return response;
        },

        async confirmed() {
            const id = this.rowIdDelete;  
            const res = await this.deleteRevision(id);
            $("#demo-delete").modal('hide');
            this.cancelled();
            if (res.data.status == '1') {
                this.$toastr.s(res.data.message);
                setTimeout(() => {
                    location.reload();
                }, 2500);

                return;
            }
            this.$toastr.w(res.data.message);
        },


        async submitForm(){
            this.preloader = true;
            try {
                setTimeout(() => {
                    localStorage.removeItem('DataContractDetail_view');
                    localStorage.removeItem('DataContractMaster_view');
                    localStorage.removeItem('DataProductDetail_view');
                    localStorage.removeItem('DataRevision_view');
                    localStorage.removeItem('DataSupplierDetail_view');
                    localStorage.removeItem('DataCustomerDetail_view');
                    localStorage.removeItem('selectedProducts_view');
                    localStorage.removeItem('selectedRevisions_view');
                    const base_url = localStorage.getItem('base_url');  
                    window.location.href = `${base_url}/contracts/list`;
                }, 2000);
            } catch (error) {
                console.log('Error al guardar los datos', error);
                this.$toastr.e('an error occurred');
            }
            this.preloader = false;
        },
        downloadPO() {
            window.location.href = '/download/po';
        },
        downloadSO() {
            window.location.href = '/download/so';
        },
        handleClick(type, version='') {
            const base_url = localStorage.getItem('base_url');
            let url = `${base_url}/contracts/`;

            if (type === 'PO') {
                url += `downloadPo/${this.contractId}/${version}`;
            } else if (type === 'SO') {
                url += `downloadSo/${this.contractId}/${version}`;
            }

            window.open(url, '_blank');
        }
    },

    async mounted() {    
        this.contractId = this.$route.params.id;
        if (!this.contractId && !localStorage.getItem('DataRevision')) {
            this.contractId = JSON.parse(localStorage.getItem('DataContractDetail')).cd_contract_id;
        }
        await this.loadRevisionDetails(this.contractId); 
    },
}
</script>
